import { useTranslation } from 'react-i18next';

import { PlanSection } from '~/modules/artist-roster/pages/artist-details/pages/media-planner/components/PlanWizard/components/PlanSection';

function RunDatesSection() {
  const { t } = useTranslation('campaign-planner', {
    keyPrefix: 'digitalCampaigns',
  });

  return (
    <PlanSection
      title={t('planWizard.sections.runDates.title')}
      description={t('planWizard.sections.runDates.description')}
    >
      {/* eslint-disable-next-line i18next/no-literal-string */}
      <p>@TODO WMG1-657 - Run Dates</p>
    </PlanSection>
  );
}

RunDatesSection.displayName = 'RunDatesSection';

export { RunDatesSection };
